<template>
  <div class="edit_event">
    <el-collapse v-model="activeNames" :accordion="true">
      <el-collapse-item
        v-for="(event, eventName) in this.events"
        :title="eventName === 'mouseEvents' ? '鼠标事件' : '数据事件'"
        :name="eventName"
        :key="eventName"
      >
        <cx-select
          :value="selectValue[eventName]"
          @change="changeSelectName(eventName, $event)"
          :selectOptions="getSelectData(eventName)"
          title="事件类型"
        />
        <div v-if="selectValue[eventName].length" :ref="eventName">
          <transition-group tag="div" name="list">
            <div
              v-for="(itemEvent, index) in event[selectValue[eventName]]"
              :class="['mt16', 'item_event', 'item_event_content', itemEvent.event.id]"
              :key="itemEvent.event.id"
            >
              <div class="top_icon">
                <div style="width: 80px" class="mr8">
                  <cx-select
                    @change="changeEventGroupId(itemEvent, $event)"
                    :selectOptions="eventGroupOptions"
                    :value="itemEvent.event.groupId"
                  />
                </div>
                <div class="right_icon">
                  <p @click="playEvent(itemEvent)" class="icon-portal-play mr8 play_btn"></p>
                  <p @mousedown="dragStart(itemEvent, index, $event)" class="icon-portal-drag-move mr8 play_btn"></p>
                  <p @click="delEvent(itemEvent)" class="icon-portal-delete1"></p>
                </div>
              </div>
              <div>
                <span class="mr8">事件动作</span><span class="suffix_text">{{ itemEvent.eventDesStr }}</span>
              </div>
              <div v-if="itemEvent.eventDesStr === '组件样式调整' || itemEvent.eventDesStr === '组件显示隐藏'">
                <span class="mr8">响应组件</span
                ><span @click="edit(itemEvent, index)" class="change_active_component_btn" @mouseover="hoverFunc(itemEvent, index, 1)" @mouseout="hoverFunc(itemEvent, index, 2)">{{
                  itemEvent.elementType
                }}</span>
              </div>
              <div v-else-if="itemEvent.eventDesStr.includes('页面打开')">
                <span class="mr8">事件动作</span>
                <el-tooltip
                  v-if="itemEvent.event.url.length > 15"
                  effect="dark"
                  :content="itemEvent.event.url"
                  placement="top-start"
                >
                  <span @click="edit(itemEvent, index)" class="change_active_component_btn">{{
                    itemEvent.event.url.slice(0, 15) + "..."
                  }}</span>
                </el-tooltip>
                <span v-else @click="edit(itemEvent, index)" class="change_active_component_btn">{{
                  itemEvent.event.url
                }}</span>
              </div>
              <div v-else-if="itemEvent.eventDesStr.includes('滚动')">
                <div v-for="(position, index) in itemEvent.event.position" :key="index">
                  <span class="mr8">{{ index ? "纵" : "横" }}轴坐标</span>
                  <el-tooltip v-if="position.length > 15" effect="dark" :content="position" placement="top-start">
                    <span @click="edit(itemEvent, index)" class="change_active_component_btn">{{
                      position.slice(0, 15) + "..."
                    }}</span>
                  </el-tooltip>
                  <span v-else @click="edit(itemEvent, index)" class="change_active_component_btn">{{ position }}</span>
                </div>
              </div>
              <div>
                <span class="mr8">事件生命周期</span>
                <lifeCycleSetting :tarEvent="itemEvent" />
              </div>
            </div>
          </transition-group>
        </div>
        <div
          v-if="dragId.length"
          :class="['mt16', 'item_event']"
          :data-test="top - 8 - topFix + 'aaa'"
          :style="{
            left: left + 'px',
            top: top + 'px',
            width: width + 'px',
            top: top + 'px',
            position: 'fixed'
          }"
        >
          <div class="top_icon">
            <div style="width: 80px" class="mr8">
              <cx-select :selectOptions="eventGroupOptions" :value="wrapper.event.groupId" />
            </div>
            <div class="right_icon">
              <p class="icon-portal-play mr8 play_btn"></p>
              <p class="icon-portal-drag-move mr8 play_btn"></p>
              <p class="icon-portal-delete1"></p>
            </div>
          </div>
          <div>
            <span class="mr8">事件动作</span><span class="suffix_text">{{ wrapper.eventDesStr }}</span>
          </div>
          <div v-if="wrapper.eventDesStr === '组件样式调整'">
            <span class="mr8">响应组件</span><span class="change_active_component_btn">{{ wrapper.elementType }}</span>
          </div>
          <div v-else-if="wrapper.eventDesStr.includes('页面打开')">
            <span class="mr8">事件动作</span>
            <el-tooltip
              v-if="wrapper.event.url.length > 15"
              effect="dark"
              :content="wrapper.event.url"
              placement="top-start"
            >
              <span class="change_active_component_btn">{{ wrapper.event.url.slice(0, 15) + "..." }}</span>
            </el-tooltip>
            <span v-else class="change_active_component_btn">{{ wrapper.event.url }}</span>
          </div>
          <div v-else-if="wrapper.eventDesStr.includes('滚动')">
            <div v-for="(position, index) in wrapper.event.position" :key="index">
              <span class="mr8">{{ index ? "纵" : "横" }}轴坐标</span>
              <el-tooltip v-if="position.length > 15" effect="dark" :content="position" placement="top-start">
                <span class="change_active_component_btn">{{ position.slice(0, 15) + "..." }}</span>
              </el-tooltip>
              <span v-else class="change_active_component_btn">{{ position }}</span>
            </div>
          </div>
          <div>
            <span class="mr8">事件生命周期</span>
            <lifeCycleSetting :tarEvent="wrapper" />
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { allEventTypes } from "utils/event"
import { componentNames } from "dependencies/base"
import bindVariable from "./bindVariable.vue"
import lifeCycleSetting from "./lifeCycleSetting.vue"
export default {
  props: {
    tarEvent: Object,
    componentVariables: Array,
    primarySelectValue: [Object || undefined]
  },
  components: {
    bindVariable,
    lifeCycleSetting
  },
  data() {
    return {
      eventGroupOptions: [
        {
          label: "默认",
          value: "primary"
        },
        {
          label: "1",
          value: "1"
        },
        {
          label: "2",
          value: "2"
        },
        {
          label: "3",
          value: "3"
        },
        {
          label: "4",
          value: "4"
        },
        {
          label: "5",
          value: "5"
        },
        {
          label: "6",
          value: "6"
        },
        {
          label: "7",
          value: "7"
        },
        {
          label: "8",
          value: "8"
        },
        {
          label: "9",
          value: "9"
        },
        {
          label: "10",
          value: "10"
        }
      ],
      activeNames: [],
      wrapper: null,
      selectValue: {
        mouseEvents: "",
        dataEvents: ""
      },
      playingEvent: {},
      dragId: "",
      width: null,
      left: 0,
      top: 0,
      leftFix: 0,
      topFix: 0,
      nextEvent: null,
      eventTypeInDrag: ""
    }
  },
  watch: {
    primarySelectValue(n, o) {
      if (n) {
        this.activeNames = [n.eventType]
        this.selectValue[n.eventType] = n.eventName
      }
    }
  },
  computed: {
    componentVariableProxy: {
      get() {
        return this.componentVariables
      },
      set(val) {
        this.$emit("update:componentVariables", val)
      }
    },
    events() {
      if (this.tarEvent !== null) {
        const { events } = this.tarEvent
        const { mouseEvents: mouseEvent, dataEvents: dataEvent } = events
        const mouseEvents = this.copyRectEvents(allEventTypes.mouseEventsTypes, mouseEvent, "mouseEvents")
        const dataEvents = this.copyRectEvents(allEventTypes.dataEventsTypes, dataEvent, "dataEvents")
        return {
          mouseEvents,
          dataEvents
        }
      } else return { mouseEvents: [], dataEvents: [] }
    }
  },
  methods: {
    changeEventGroupId(itemEvent, $event) {
      const param = {
        name: "groupId",
        value: $event,
        event: itemEvent.event,
        eventName: itemEvent.eventNameDes,
        eventType: itemEvent.eventType
      }
      this.$event
        .changeEventAttr(param)
        .then(res => {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "success",
            message: "修改成功"
          })
        })
        .catch(err => {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "error",
            message: "修改失败"
          })
        })
    },
    playEvent(tarEvent) {
      const { event } = tarEvent
      const { eventMovement, movementType, ids, id, update, repeat, duration } = event
      if (this.playingEvent[id]) return
      this.playingEvent[id] = true
      const primaryTransitionTime = 1
      if (eventMovement === "component" && movementType === "options") {
        //调整样式的组件，需要在样式改变完成后 还原之前的样式
        const componentId = this.$event.getIdsByStrId(ids)
        const oldAttr = this.getAttrById(this.$store.state[this.request_prefix], ids)
        const oldOptions = JSON.parse(JSON.stringify(oldAttr.options ? oldAttr.options : oldAttr))
        const els = Array.from(document.getElementsByClassName(componentId))
        if (!update.transitionTime) {
          //如果没有动画 就设置一个默认动画
          els.forEach(el => (el.style.transition = `all ${primaryTransitionTime}s ease 0s`))
        }
        setTimeout(() => {
          this.$store.dispatch(this.request_prefix + "/changeAllOptions", { ...ids, options: oldOptions, isEditEvent: true })
          setTimeout(() => {
            els.forEach(el => (el.style.transition = "0s"))
            delete this.playingEvent[id]
          }, ((update.transitionTime ? update.transitionTime : primaryTransitionTime) + 2) * 500)
        }, ((update.transitionTime ? update.transitionTime : primaryTransitionTime) + 2) * 800)
      }
      if (eventMovement === "component" && movementType === "show") {
        let div = isNaN(repeat) ? 5 : Number(repeat) + 1
        setTimeout(() => {
          const idsStr = this.$event.getIdsByStrId({ ...ids })
          const rootEl = document.getElementsByClassName(idsStr)[0]
          const el = rootEl.getElementsByClassName("rect")[0]
          const removeClassList = Array.from(el.classList).filter(it => it.includes("animate__"))
          el.classList.remove(...removeClassList)
          delete this.playingEvent[id]
        }, duration * div * 1000)
      }
      this.$event.trigger(event, null)
    },
    fixSize(e) {
      const el = this.$el.getElementsByClassName("item_event")[0]
      this.width = el.offsetWidth
      this.height = el.offsetHeight
      this.leftFix = e.layerX
      this.topFix = e.offsetY
    },
    dragStart(tarEvent, index, e) {
      const { eventType, eventNameDes: eventName, event } = tarEvent
      const { from: publishComponentIds, id: eventId, ids: toIds } = event
      this.eventTypeInDrag = eventType
      this.wrapper = tarEvent
      this.nextEvent = this.events[eventType][eventName][index + 1]
      this.dragId = tarEvent.event.id
      //先删除 后插入
      this.$event.deleteEvent({ publishComponentIds, eventId, eventType, eventName, toIds })
      this.fixSize(e)
      this.setPosition(e)
      window.addEventListener("mousemove", this.dragMove)
      window.addEventListener("mouseup", this.drop)
    },
    dragMove(e) {
      this.setPosition(e)
    },
    drop(e) {
      this.changeEventPosition(e)
      this.removeEventListener()
      this.dragId = ""
      this.eventTypeInDrag = ""
      this.width = null
      this.top = null
      this.wrapper = null
      this.nextEvent = null
    },
    changeEventPosition(e) {
      const { eventType, eventNameDes: eventName, event } = this.wrapper
      let wrapperEl = this.$refs[this.eventTypeInDrag][0]
      const clientRect = this.checkElPosition(e, wrapperEl)
      const insertParam = {
        publishComponentIds: event.from,
        eventType,
        event,
        eventName,
        nextEvent: this.nextEvent
      }
      if (!clientRect) {
        // 没有在父容器内 不用交换顺序 还原之前顺序就行
        this.$event.insertEvent(insertParam)
      } else {
        const { x, y, width, height } = clientRect
        const innerY = e.clientY - y
        const childNodes = wrapperEl.childNodes[0].childNodes
        let insertIndex = -1
        let totalH = 0
        for (let i = 0; i < childNodes.length; i++) {
          if (innerY > totalH) {
            totalH += childNodes[i].offsetHeight
            insertIndex++
          } else break
        }
        const nextEvent = this.events[eventType][eventName][insertIndex]
        insertParam.nextEvent = nextEvent
        this.$event.insertEvent(insertParam)
      }
    },
    checkElPosition(e, wrapperEl) {
      //检查鼠标在不在可drop区域内
      const { clientX, clientY } = e
      const { x, y, width, height } = wrapperEl.getBoundingClientRect()
      if (clientX > x && clientX < x + width && clientY > y && clientY < y + height) return { x, y, width, height }
      return false
    },
    setPosition(e) {
      this.left = e.clientX - 10 - this.leftFix + 14 + 8 + 8
      this.top = e.clientY - 20 - this.topFix
    },
    removeEventListener() {
      window.removeEventListener("mousemove", this.dragMove)
      window.removeEventListener("mouseup", this.drop)
    },
    delEvent(tarEvent) {
      this.$confirm("确认删除该事件吗？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showClose: false,
        dangerouslyUseHTMLString: "<p>确认删除该事件吗？？</p>",
        iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
        cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
        confirmButtonClass: `${this.request_prefix}_confirm_button`,
        customClass: `${this.request_prefix}_confirm custom_warning_dialog`
      })
        .then(() => this.del(tarEvent))
        .catch(err => console.log(err))
    },
    del(tarEvent) {
      const { event, eventNameDes: eventName, eventType } = tarEvent
      const { eventMovement, movementType, ids, id, update, from } = event
      this.$event.deleteEvent({
        publishComponentIds: { ...from },
        eventId: id,
        eventType,
        eventName,
        toIds: ids
      })
    },
    getSelectData(k) {
      //mouseEvent sTypes
      return allEventTypes[k + "Types"]
    },
    changeSelectName(eventName, value) {
      this.selectValue[eventName] = value
    },
    getName(k) {
      const mouseName = allEventTypes.mouseEventsTypes.find(it => it.value === k)
      if (mouseName) {
        return mouseName.label
      } else {
        return allEventTypes.dataEventsTypes.find(it => it.value === k).label
      }
    },
    edit(tarEvent, index) {
      const { eventDesStr, event, eventType, eventNameDes, elementType } = tarEvent
      this.$emit("editEvent", {
        eventType,
        eventNameDes,
        event,
        index,
        elementType
      })
    },
    copyRectEvents(eventTypes, events, eventType) {
      const res = {}
      eventTypes.forEach(eventDes => {
        const { label, value } = eventDes
        res[value] = []
        events[value]?.forEach((event, index) => {
          const _event = {
            eventDesStr: this.getEventType(event.eventMovement, event.movementType),
            event,
            eventType,
            eventNameDes: value,
            eventName: label,
            id: event.id
          }
          if (event.ids) {
            const attr = this.getAttrById(this.$store.state[this.request_prefix], event.ids)
            const elementType = attr?.options ? attr?.options.innerElement : attr?.innerElement
            _event.elementType = componentNames[elementType || "container"]
            if(elementType === 'swiperComponent'){
              _event.elementType = '轮播'
            }
            if(attr?.options && attr?.options.innerElementInTree){
              _event.elementType = attr?.options.innerElementInTree
            }
          }
          res[value].push(_event)
        })
      })
      return res
    },
    getEventType(eventMovement, movementType) {
      if (eventMovement === "component" && movementType === "options") {
        return "组件样式调整"
      }
      if (eventMovement === "component" && movementType === "show") {
        return "组件显示隐藏"
      }
      if (eventMovement === "window" && movementType === "self") {
        return "当前页面打开"
      }
      if (eventMovement === "window" && movementType === "open") {
        return "新页面打开"
      }
      if (eventMovement === "window" && movementType === "scroll") {
        return "滚动窗口"
      }
      if (eventMovement === "window" && movementType === "scrollBy") {
        return "相对滚动"
      }
    },
    hoverFunc(tarEvent, index, type) {
      const { event } = tarEvent
      const { ids } = event
      const idsStr = this.$event.getIdsByStrId({ ...ids })
      const rootEl = document.getElementsByClassName(idsStr)[0]
      const elClassList = rootEl.classList || []
      if(type === 1){
        elClassList.add('hover-item')
      }else{
        for (let i = 0; i < elClassList.length; i++) {
          if (elClassList[i].includes("hover-item")) elClassList.remove(elClassList[i--])
        }
      }
    }
  }
}
</script>

<style scoped>
.event {
  border: 1px solid gray;
  border-radius: 4px;
  padding: 10px 15px;
}
.inner_collapse /deep/ .el-collapse-item {
  padding: 0 24px !important;
}
.inner_collapse /deep/ .el-collapse-item_content {
  padding: 0 !important;
}
.top_icon {
  margin-top: 4px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.right_icon {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
.right_icon > p:hover {
  cursor: pointer;
}
.play_btn {
  font-size: 13px;
}
.change_active_component_btn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 3px 20px;
  cursor: pointer;
}

.item_event {
  padding: 4px 8px;
  border: 1px solid gray;
  border-radius: 4px;
}

.item_event_content {
  transition: all 0.5s;
  width: 100%;
}
.list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(90px);
}
.list-leave-active {
  position: absolute;
}
</style>
